import type { ReactNode } from 'react'

export interface TestLayoutProps {
  children: ReactNode
  variant?: 'plain' | 'card'
}

export function TestCardSurface({ children }: { children: ReactNode }) {
  return (
    <div className="mx-auto flex min-h-[calc(100dvh-2rem)] w-full max-w-[960px] flex-col items-center justify-center rounded-[20px] bg-lc-bg-primary px-3 py-12 text-center shadow-lc-v3-card md:min-h-[calc(100dvh-5rem)]">
      {children}
    </div>
  )
}

/**
 * 학습자 평가 풀스크린 layout. 헤더 / 탭바 미노출 — 학생이 다른 메뉴로 이동할 수 없는 집중 컨텍스트.
 */
export function TestLayout({ children, variant = 'plain' }: TestLayoutProps) {
  if (variant === 'card') {
    return (
      <main className="flex min-h-dvh bg-lc-bg-secondary p-4 md:p-10">
        <TestCardSurface>{children}</TestCardSurface>
      </main>
    )
  }

  return (
    <main className="min-h-screen bg-lc-gray-c100 flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-[600px] flex flex-col items-center text-center">
        {children}
      </div>
    </main>
  )
}
